import { render, staticRenderFns } from "./AccessControlForm.vue?vue&type=template&id=b47183a6&scoped=true&"
import script from "./AccessControlForm.vue?vue&type=script&lang=ts&"
export * from "./AccessControlForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccessControlForm.vue?vue&type=style&index=0&id=b47183a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47183a6",
  null
  
)

export default component.exports